import Styles from './Images.module.scss'
import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'
import { Button } from 'blaze-ui/Button'
import { Images } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import { useEffect } from 'react'
import { useUnsplashImages } from 'hooks/queries/useUnsplashImages'
import { collectResults } from 'utils/query'
import { ShimmeringColor } from 'components/BrandWizardVisualAnalysisModal/LoadingState'
import { MediaFilePreview } from './MediaFilePreview'

interface Props {
  isDisabled?: boolean
  imageKeywords?: string[]
  isLoading?: boolean
}

export const StockImages = ({ isDisabled, imageKeywords, isLoading }: Props) => {
  const imagePickerContext = useImagePickerContext()
  const { selectedImages, initialQuery, setProvider, toggleSelectedImage } = imagePickerContext
  const query = imageKeywords?.join(' ') || initialQuery || ''
  const unsplashQuery = useUnsplashImages({ query, perPage: 4 })
  const results = collectResults(unsplashQuery, (data) => data.results || data)
  const stockImages = results.map((item) => {
    return {
      url: item.urls.regular,
      unsplash: {
        authorUsername: item.user.username,
        authorName: item.user.name,
        id: item.id,
        query,
      },
    }
  })

  useEffect(() => {
    if (stockImages.length > 0 && !selectedImages.length) toggleSelectedImage(stockImages[0])
  }, [unsplashQuery.isFetched]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={Styles.imagesSection}>
      <div className={Styles.header}>
        <Text variant="largeList">Choose a stock photo</Text>
      </div>
      <div className={Styles.imagesCard}>
        <div className={Styles.imagesGrid}>
          {(isLoading || stockImages.length === 0) &&
            stockImages.slice(0, 4).map((_, i) => <ShimmeringColor aspectRatio={1} width={152} height={152} key={i} />)}
          {!isLoading &&
            stockImages
              .slice(0, 4)
              .map((stockImage) => (
                <MediaFilePreview
                  ariaLabel="unsplash-image"
                  key={stockImage.unsplash.id}
                  mediaFile={stockImage}
                  isDisabled={isDisabled}
                  isSelected={stockImage.unsplash.id === selectedImages[0]?.unsplash?.id}
                />
              ))}
        </div>
        <Button
          frontIcon={Images}
          variant="tertiary"
          isDisabled={stockImages.length === 0 || isDisabled}
          onPress={() => setProvider('stock')}
        >
          Browse all stock photos
        </Button>
      </div>
    </div>
  )
}
